const googleTranslateInit = (isEmbed, isGoogletranslateEnambed) => {
  if (!isEmbed && isGoogletranslateEnambed) {
    const lang = document.documentElement.lang;
    const selectField = document.querySelector(
      "#google-translate-element select"
    );
    if (selectField) {
      for (let i = 0; i < selectField.children.length; i++) {
        const option = selectField.children[i];
        if (option.value === lang) {
          selectField.selectedIndex = i;
          // eslint-disable-next-line no-undef
          selectField.dispatchEvent(new Event("change"));
          break;
        }
      }
    }
  }
};
export default googleTranslateInit;
